"use strict";
exports.__esModule = true;
exports.isValidNectarCardNumber = void 0;
var luhn_1 = require("./utils/luhn");
var NECTAR_PREFIX = '98263000';
var NECTAR_LENGTH = 19;
function isValidNectarCardNumber(cardNumber) {
    return cardNumber.length === NECTAR_LENGTH && cardNumber.substring(0, 8) === NECTAR_PREFIX && luhn_1.checkLuhn(cardNumber);
}
exports.isValidNectarCardNumber = isValidNectarCardNumber;
//# sourceMappingURL=nectar.js.map